
export default {
  props:{
    type: {
      validator(value) {
        return ['default', 'error'].includes(value)
      },
      default: 'default'
    }
  }
}
